import React, { Component } from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { isEmpty } from '../../../util/isEmpty';
import ErrorBoundary from '../../../ErrorBoundary';
import LoadableSpin from '../../common/LoadableSpin';
import { showBlurCards } from '../../../util/showBlurCards';
import FilterRates from "../FilterRates";
import PropTypes from 'prop-types';
import TransactionType from './TransactionType';
import ScheduleRateFilter from './ScheduleRateFilter';
// code splitting
const LclAirSlider = loadable(() => import('../lclAirSlider/LclAirSlider'), {
  fallback: <LoadableSpin />,
});

const FCLContainerType = loadable(
  () => import('../fclContainerType/FCLContainerType'),
  {
    fallback: <LoadableSpin />,
  }
);

const RoleService = loadable(() => import('../sidebarServices/RoleService'), {
  fallback: <LoadableSpin />,
});

const IncotermService = loadable(
  () => import('../sidebarServices/IncotermService'),
  {
    fallback: <LoadableSpin />,
  }
);

/**
 * @component
 * @name SideComponent
 * @category Search Page
 * @subcategory Sidebar
 * @description all sidebar components on search page
 * <br> <br>
 * **Example**
 * ```js
 *   <SideComponent/>
 * ```
 */
class SideComponent extends Component {
  /**
   * @description whether there is no rate card present in rate json.
   * `false` - at least one rate card is present, `true` - no rate card is present
   * <br> <br>
   * **isZeroRateCardsExist() -> {Boolean}**
   * <br><br>
   * Returns:  Type: void
   */
  isZeroRateCardsExist = () => {
    const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;

    const jsonData =
      (!isEmpty(seaFCLJSON) && seaFCLJSON) ||
      (!isEmpty(seaLCLJSON) && seaLCLJSON) ||
      (!isEmpty(airJSON) && airJSON) ||
      {};
    const jsonItemsArr =
      (!isEmpty(jsonData) &&
        !isEmpty(jsonData.rates) &&
        Array.isArray(
          jsonData.rates.fcl || jsonData.rates.lcl || jsonData.rates.air
        ) &&
        (jsonData.rates.fcl || jsonData.rates.lcl || jsonData.rates.air)) ||
      [];

    return jsonItemsArr.length === 0;
  };
  render() {
    const { seaFCLJSON, seaLCLJSON, airJSON, enableSearchBlurCards } =
      this.props;

    let showSidebarServices = true;
    // if show blur cards are shown hide side bar roleservices
    const showResultBlurCards = showBlurCards(seaFCLJSON, seaLCLJSON, airJSON);

    //if blur cards are in focus or zero rate cards exist then don't show side bars services
    if (
      (showResultBlurCards && enableSearchBlurCards) ||
      this.isZeroRateCardsExist()
    ) {
      showSidebarServices = false;
    }

    return (
      <ErrorBoundary>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <TransactionType />
          {!isEmpty(seaFCLJSON) && <FCLContainerType />}
          {!isEmpty(seaLCLJSON) && <LclAirSlider />}
          {!isEmpty(airJSON) && <LclAirSlider />}

          {showSidebarServices && (
            <>
              <RoleService />
              <FilterRates/>
              <ScheduleRateFilter />
              <IncotermService />
            </>
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

SideComponent.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,

  /**
   * in-app error message notify, shown at bottom-right in case of network error, server error, etc.
   */
  errorMessage: PropTypes.string,
  /**
   * should show a loading spinner
   */
  loading: PropTypes.bool,
  /**
   * url (it has relevant params) so that it can be used in browser address field
   */
  url: PropTypes.string,

  /**
   * whether to show [No Result]{@link NoResult} card
   */
  showNoResultCard: PropTypes.bool,
  /**
   * email address of user for blur cards
   */
  userEmailBlurCards: PropTypes.string,
  /**
   * whether to show blur cards or not on search page.
   */
  enableSearchBlurCards: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    // config: state.config,
    seaFCLJSON: state.route.seaFCLJSON,
    seaLCLJSON: state.route.seaLCLJSON,
    airJSON: state.route.airJSON,

    errorMessage: state.route.errorMessage,
    loading: state.route.loading,
    url: state.route.url,

    showNoResultCard: state.code_config.showNoResultCard,
    userEmailBlurCards: state.cache.userEmailBlurCards,
    enableSearchBlurCards: state.code_config.enableSearchBlurCards,
  };
};

export default connect(mapStateToProps, actions)(SideComponent);
